<select id='paginationDropdownPages' *ngIf="!(totalItems <= pageSizes[0])" name="pageSize" [(ngModel)]="currentPageSize" class="form-control">
  <option *ngFor="let size of pageSizes; index as i" [value]="size" [selected]="size === currentPageSize">{{ size }}</option>
</select>

<ch-pagination
  [totalItems]="totalItems"
  [pageNumber]="pageNumber"
  [pageSize]="currentPageSize"
  (pageChanged)="onPageChanged($event)"
></ch-pagination>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/pagination-dropdown/pagination-dropdown.component.html